import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { BottomSheetService } from 'src/app/services/bottomSheet/bottom-sheet.service';
import { SheetDeactivateComponent } from '../sheet-deactivate/sheet-deactivate.component';
import { TaggingService } from 'src/app/services/tagging.service';
import { SetEventInterface } from 'src/app/interfaces/tagging.interface';

@Component({
    selector: 'app-panel-schedule',
    templateUrl: './panel-schedule.component.html',
    styleUrls: ['./panel-schedule.component.scss'],
    standalone: false
})
export class PanelScheduleComponent {

  #bss = inject(BottomSheetService);

  #taggingSergice = inject(TaggingService);

  public status: boolean = false;

  @Input() recharges: any = [];

  @Input() activeEditRecharge: boolean;

  @Output() setPaymentSchedule: EventEmitter<any> = new EventEmitter();

  @Output() eventEditSchedule: EventEmitter<any> = new EventEmitter();

  public arrayFrecuency: any[] = [
    { value: 'SEMANAL', label: 'Semanal', active: false },
    { value: 'QUINCENAL', label: 'Quincenal', active: false },
    { value: 'MENSUAL', label: 'Mensual', active: false }
  ];

  public editPaymentSchesule() {
    this.#tagging(true);
    this.eventEditSchedule.emit(this.recharges);
  }

  public changeStatus(_event: Event): void {
    const input = _event.target as HTMLInputElement;
    if (!input.checked) {
      _event.preventDefault();
      this.#bss.show(SheetDeactivateComponent, {
        onContinue: () => {
          this.status = false;
          this.#tagging();
          this.setPaymentSchedule.emit(this.status);
        },
        flow: true,
        config: {
          closeLabel: "Cerrar",
        },
      });
      return;
    }
    this.status = input.checked;
    this.#tagging();
    this.setPaymentSchedule.emit(this.status);
  }

  #tagging(_edit?: boolean): void {
    const label = this.status ? 'on' : 'off';
    const event: SetEventInterface = {
      event: "payments",
      categoria: 'recarga_celular',
      accion: 'detalle',
      etiqueta: _edit ? 'editar' : `pago_automatico_${label}`,
      canalBanco: "supermovil",
      url: 'recarga_celular/detalle',
      userID: '',
    }
    this.#taggingSergice.setEvent(event);
  }
}
